import styled from "styled-components";

export const UserStatusPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px; // TODO возможно глобально надо поставить
`;

export const UserStatusPageContentStyled = styled.div<{inactive: boolean}>`
    flex: 1;

    .inactive {
        opacity: ${props => props.inactive ? 0.5 : 1};
    }
`;

export const UserStatusPageButtonStyled = styled.div`
    margin: 0 -16px;
    padding: 8px 16px 24px 16px;
    position: sticky;
    bottom: 0;
    background-color: var(--color-background-primary);
    outline: 1px solid var(--color-background-primary);
`;

export const UserStatusPageTermsStyled = styled.div`
    margin-bottom: 24px;
    margin-top: 24px;
`;
